<template>
  <div class="background_concept">
    <div class="concept_index_text">
      <p style="font-size: 22px;margin-bottom: 20px">我们的理念</p>
      <p style="font-size: 27px;margin-bottom: 20px">寻找价值洼地 赋能新生力量</p>
      <p style="font-size: 12px">我们无法预测哪里有价值洼地，但出现洼地的地方，</p>
      <p style="font-size: 12px">我们会出现，这是勤奋，也是风格。</p>
      <p style="font-size: 12px">是我们选择了快速生成的洼地，也是新崛起的力量选择了我们。</p>
      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>

    </div>

  </div>
</template>


<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: 'Concept_index_m',
  components: {
    DownOutlined,

  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>


<style scoped>
.background_concept {
  background-image: url("../../../assets/background/concept_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

.concept_index_text {
  padding-top: 40vh;
  text-align: center;
}

.index_down {
  padding-top: 2vh;
}
</style>